import StudentBreadCrumbs from './student-bread-crumbs'

export default StudentBreadCrumbs
